// extracted by mini-css-extract-plugin
export var rateTable = "_45-0";